export default function ProductPage({ title, subtitle, features, ctaTitle }) {
  return (
    <main>
      <section className="page-hero">
        <div className="container">
          <h1>{title}</h1>
          <p>{subtitle}</p>
          <a href="/#contact" className="btn btn-primary" style={{ marginTop: 24, display: 'inline-block' }}>Get Started</a>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {features.map((f, i) => (
            <div className={`feature${i % 2 === 1 ? ' reverse' : ''}`} key={i}>
              <div>
                <h2>{f.heading}</h2>
                <p>{f.text}</p>
              </div>
              <div className="feature-img">{f.icon}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section" style={{ background: 'var(--bg)' }}>
        <div className="container">
          <div className="cta-banner">
            <h2>Ready to try {ctaTitle}?</h2>
            <p style={{ marginBottom: 24, opacity: 0.95 }}>Start free today — no credit card required.</p>
            <a href="#contact" className="btn">Request Callback</a>
          </div>
        </div>
      </section>
    </main>
  );
}
